import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const TRA_CUSTOM_02_Schema = {
  fields: {
    eduForm: {
      tpmId: { initial: '', label: 'TPM 식별자' },
      eduTypeCd: { initial: '', label: '교육구분코드', required: 'Y' },
      eduNmCd: { initial: '', label: '교육명코드', required: 'Y' },
      eduContentsCd: { initial: '', label: '교육내용코드', required: 'Y' },
      eduDt: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '교육일',
        required: 'Y',
      },
      eduTm: { initial: '', label: '교육시간', required: 'Y' },
      eduPlace: { initial: '', label: '교육장소', required: 'Y' },
      eduManager: { initial: '', label: '교육담당자', required: 'Y' },

      eduTargetMCnt: { initial: '', label: '교육대상자수(남)', required: 'Y' },
      eduExecMCnt: { initial: '', label: '교육실시자수(남)', required: 'Y' },
      eduNoExecMCnt: {
        initial: '',
        label: '교육미실시자수(남)',
        required: 'Y',
      },

      eduTargetWCnt: { initial: '', label: '교육대상자수(여)', required: 'Y' },
      eduExecWCnt: { initial: '', label: '교육실시자수(여)', required: 'Y' },
      eduNoExecWCnt: {
        initial: '',
        label: '교육미실시자수(여)',
        required: 'Y',
      },

      eduNoExecReason1: { initial: '', label: '미실시사유1' },
      eduNoExecReason2: { initial: '', label: '미실시사유2' },
      eduNoExecReason3: { initial: '', label: '미실시사유3' },

      // 세이프온(SELF_YN=N) 간편등록 시 교육강사 선택
      eduInstructorId: {
        initial: '',
        label: '교육강사',
        required: 'Y',
        requiredWhen: ({ row }) =>
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() !== 'Y',
      },
      eduInstructorNm: { initial: '', label: '교육강사명' },
      eduInstructorPosition: { initial: '', label: '교육강사직책' },

      eduImageFileName1: { initial: '', label: '사진파일명1' },
      eduImageSaveName1: { initial: '', label: '사진저장명1' },
      eduImageFilePath1: { initial: '', label: '사진경로1' },

      eduImageFileName2: { initial: '', label: '사진파일명2' },
      eduImageSaveName2: { initial: '', label: '사진저장명2' },
      eduImageFilePath2: { initial: '', label: '사진경로2' },

      significant: { initial: '', label: '특이사항' },

      selfYn: { initial: 'N', label: '자체등록여부' },
      eduTypeSelfNm: { initial: '', label: '교육구분(자체)' },
      eduSelfNm: { initial: '', label: '교육명(자체)' },
      eduSelfContents: { initial: '', label: '교육내용(자체)' },
      selfImageFileName: { initial: '', label: '자체첨부원본명' },
      selfImageSaveName: { initial: '', label: '자체첨부저장명' },
      selfImageFilePath: { initial: '', label: '자체첨부경로' },
    },
    approverRejectForm: {
      tpmId: { initial: '', label: 'TPM 식별자', required: 'Y' },
      returnDetail: { initial: '', label: '반려 사유', required: 'Y' },
    },
    approverSignForm: {
      tpmId: { initial: '', label: 'TPM 식별자', required: 'Y' },
      signPath: { initial: '', label: '결재 서명 경로', required: 'Y' },
    },
    memForm: {
      tpdId: { initial: '', label: '참석자식별자' },
      no: { initial: '', label: '순번' },
      jobType: { initial: '', label: '직종' },
      tpaUserId: { initial: '', label: '참석자ID' },
      userNm: { initial: '', label: '성명' },
      remark: { initial: '', label: '비고' },
    },
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd ?? ''),
      StartDt: (_, context) =>
        Commons.EncryptAES(context.search?.startDate ?? ''),
      EndDt: (_, context) => Commons.EncryptAES(context.search?.endDate ?? ''),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText ?? ''),
      UserId: (_, context) => context.userInfo.userid,
    },
    search2: {
      TpmId: (_, context) =>
        Commons.EncryptAES(((context.tpmId || '0') ?? '0').toString()) || '',
    },
    search3: {
      UserId: (_, context) => context.userInfo.userid,
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo.authCd),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo.coCd),
      custCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText),
    },

    save1: {
      TpmId: (row) =>
        Commons.EncryptAES(((row.tpmId || '0') ?? '0').toString()) || '',

      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd ?? '') || '',

      SelfYn: (row) => {
        const y =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return Commons.EncryptAES(y ? 'Y' : 'N') || '';
      },

      EduDt: (row) =>
        Commons.EncryptAES(row.eduDt || dayjs().format('YYYY-MM-DD')) || '',
      EduTm: (row) => Commons.EncryptAES(row.eduTm || '') || '',
      EduPlace: (row) => Commons.EncryptAES(row.eduPlace || '') || '',
      EduManager: (row) => Commons.EncryptAES(row.eduManager || '') || '',

      EduInstructorId: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return Commons.EncryptAES(self ? '' : row.eduInstructorId || '') || '';
      },

      EduTypeCd: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          return Commons.EncryptAES('') || '';
        }
        const raw = row.eduTypeCd || '';
        const normalized = raw
          ? raw.startsWith('EG_')
            ? raw
            : `EG_${raw}`
          : '';
        return Commons.EncryptAES(normalized) || '';
      },

      EduNmCd: (row, context) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          return Commons.EncryptAES('') || '';
        }
        return (
          Commons.EncryptAES(context.isEtcEduType ? '' : row.eduNmCd || '') ||
          ''
        );
      },
      EduContentsCd: (row, context) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          return Commons.EncryptAES('') || '';
        }
        return (
          Commons.EncryptAES(
            context.isEtcEduType ? '' : row.eduContentsCd || ''
          ) || ''
        );
      },

      EtcEduNm: (row, context) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          return Commons.EncryptAES('') || '';
        }
        return (
          Commons.EncryptAES(context.isEtcEduType ? row.eduNmCd || '' : '') ||
          ''
        );
      },
      EtcEduContents: (row, context) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          // 자체등록의 교육내용은 EDU_SELF_CONTENTS에 저장한다.
          return Commons.EncryptAES('') || '';
        }
        return (
          Commons.EncryptAES(
            context.isEtcEduType ? row.eduContentsCd || '' : ''
          ) || ''
        );
      },

      EduTypeSelfNm: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.eduTypeSelfNm || row.eduTypeNm || '' : '';
        return Commons.EncryptAES(v) || '';
      },
      EduSelfNm: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.eduSelfNm || row.etcEduNm || '' : '';
        return Commons.EncryptAES(v) || '';
      },

      // 자체등록의 교육내용
      EduSelfContents: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.eduSelfContents || row.etcEduContents || '' : '';
        return Commons.EncryptAES(v) || '';
      },

      EduTargetMCnt: (row) =>
        Commons.EncryptAES((row.eduTargetMCnt || '0').toString()) || '',
      EduTargetWCnt: (row) =>
        Commons.EncryptAES((row.eduTargetWCnt || '0').toString()) || '',
      EduExecMCnt: (row) =>
        Commons.EncryptAES((row.eduExecMCnt || '0').toString()) || '',
      EduExecWCnt: (row) =>
        Commons.EncryptAES((row.eduExecWCnt || '0').toString()) || '',
      EduNoExecMCnt: (row) =>
        Commons.EncryptAES((row.eduNoExecMCnt || '0').toString()) || '',
      EduNoExecWCnt: (row) =>
        Commons.EncryptAES((row.eduNoExecWCnt || '0').toString()) || '',

      EduNoExecReason1: (row) =>
        Commons.EncryptAES(row.eduNoExecReason1 || '') || '',
      EduNoExecReason2: (row) =>
        Commons.EncryptAES(row.eduNoExecReason2 || '') || '',
      EduNoExecReason3: (row) =>
        Commons.EncryptAES(row.eduNoExecReason3 || '') || '',

      EduImageFileName1: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageFileName1 || '') || ''
        );
      },
      EduImageSaveName1: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageSaveName1 || '') || ''
        );
      },
      EduImageFilePath1: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageFilePath1 || '') || ''
        );
      },
      EduImageFileName2: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageFileName2 || '') || ''
        );
      },
      EduImageSaveName2: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageSaveName2 || '') || ''
        );
      },
      EduImageFilePath2: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        return (
          Commons.EncryptAES(self ? '' : row.eduImageFilePath2 || '') || ''
        );
      },

      SelfImageFileName: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.selfImageFileName || '' : '';
        return Commons.EncryptAES(v) || '';
      },
      SelfImageSaveName: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.selfImageSaveName || '' : '';
        return Commons.EncryptAES(v) || '';
      },
      SelfImageFilePath: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        const v = self ? row.selfImageFilePath || '' : '';
        return Commons.EncryptAES(v) || '';
      },

      Significant: (row) => {
        const self =
          String(row.selfYn ?? row.SELF_YN ?? 'N').toUpperCase() === 'Y';
        if (self) {
          return Commons.EncryptAES('') || '';
        }
        return Commons.EncryptAES(row.significant || '') || '';
      },

      UserId: (_, context) => context.userInfo?.userid || '',
    },

    save2: {
      TpdId: (row) => Commons.EncryptAES(row.tpdId || ''),
      TpmId: (_, context) => Commons.EncryptAES(context.tpmId || ''),
      No: (row) => Commons.EncryptAES(row.no || ''),
      TpaUserId: (row) => Commons.EncryptAES(row.tpaUserId || ''),
      UserNm: (row) => Commons.EncryptAES(row.userNm || ''),
      JobType: (row) => Commons.EncryptAES(row.jobType || ''),
      Remark: (row) => Commons.EncryptAES(row.remark || ''),
      SignYn: (row) =>
        Commons.EncryptAES(
          String(row.signYn ?? row.SIGN_YN ?? 'N').toUpperCase()
        ) || '',
      SignPath: (row) =>
        Commons.EncryptAES(row.signPath ?? row.SIGN_PATH ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    approverReject: {
      TpmId: (row) =>
        Commons.EncryptAES(((row.tpmId || '0') ?? '0').toString()) || '',
      ReturnDetail: (row) => Commons.EncryptAES(row.returnDetail || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    approverSign: {
      TpmId: (row) =>
        Commons.EncryptAES(((row.tpmId || '0') ?? '0').toString()) || '',
      SignPath: (row) => Commons.EncryptAES(row.signPath || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    returnHistory: {
      TpmId: (row) =>
        Commons.EncryptAES(((row.tpmId || '0') ?? '0').toString()) || '',
    },

    delete1: {
      TpmId: (row) =>
        Commons.EncryptAES(((row.tpmId || '0') ?? '0').toString()) || '',
    },
    delete2: {
      TpdId: (row) =>
        Commons.EncryptAES(((row.tpdId || '0') ?? '0').toString()) || '',
    },

    /** QR 세션 생성 — context: { search, userInfo, expireHours, tpmId } */
    qrSessionCreate: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd ?? '') || '',
      UserId: (_, context) =>
        Commons.EncryptAES(context.userInfo?.userid ?? '') || '',
      TpmId: (_, context) => {
        const v = context.tpmId;
        if (v === undefined || v === null || v === '') {
          return Commons.EncryptAES('') || '';
        }
        return Commons.EncryptAES(String(v)) || '';
      },
      ExpireHours: (_, context) => context.expireHours ?? 48,
    },
    /** QR 세션 참석 임시 명단 조회 — context: { sessionId } 평문 sessionId */
    qrSessionPoll: {
      SessionId: (_, context) =>
        Commons.EncryptAES((context.sessionId ?? '').toString()) || '',
    },
    /** QR 세션 → 교육일지 바인딩 — context: { sessionId, tpmId, tpaUserIds? } */
    qrSessionBind: {
      SessionId: (_, context) =>
        Commons.EncryptAES((context.sessionId ?? '').toString()) || '',
      TpmId: (_, context) =>
        Commons.EncryptAES((context.tpmId ?? '').toString()) || '',
      UserId: (_, context) =>
        Commons.EncryptAES(context.userInfo?.userid ?? '') || '',
      TpaUserIdsFilterYn: (_, context) =>
        Array.isArray(context.tpaUserIds)
          ? Commons.EncryptAES('Y') || ''
          : '',
      TpaUserIdsCsv: (_, context) =>
        Array.isArray(context.tpaUserIds)
          ? Commons.EncryptAES(
              context.tpaUserIds
                .map((id) => String(id ?? '').trim())
                .filter(Boolean)
                .join(',')
            ) || ''
          : '',
    },
  },
};
